/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { SelfCheckinTokensResponse } from '../../models/self-checkin-tokens-response';

export interface GetSelfCheckinTokens$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
}

export function getSelfCheckinTokens(http: HttpClient, rootUrl: string, params: GetSelfCheckinTokens$Params, context?: HttpContext): Observable<StrictHttpResponse<SelfCheckinTokensResponse>> {
  const rb = new RequestBuilder(rootUrl, getSelfCheckinTokens.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SelfCheckinTokensResponse>;
    })
  );
}

getSelfCheckinTokens.PATH = '/administration/organization-sites/{organizationSiteKey}/self-checkin-tokens';
